import { render, staticRenderFns } from "./EditMicroprotocols.vue?vue&type=template&id=25815618&"
import script from "./EditMicroprotocols.vue?vue&type=script&lang=js&"
export * from "./EditMicroprotocols.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports